import { observable, computed, action, makeObservable } from 'mobx';

// configure({ enforceActions: true});
class Store {
  controlPanelState = 'search';
  searchFiltersState = 'form';
  isSpeedDialOpen = false;
  isAnalysisPanelOpen = false;
  isMapVisible = false;
  isContentVisible = false;
  feedbackModalOpen = false;
  version = 'v2';
  REGISTRATION_VERSION = 'v2';

  mapLayers = [
    {
      name: 'coned_hosting_capacity',
      label: 'Hosting Capacity'
    },
    {
      name: 'coned_hosting_capacity_lines',
      label: 'Feeder Hosting Capacity'
    },
    {
      name: 'powerlines',
      label: 'Powerlines'
    },
    {
      name: 'openweather_solar',
      label: 'Temperature'
    },
    {
      name: 'openweather_wind',
      label: 'Wind'
    },
    {
      name: 'openweather_clouds',
      label: 'Cloud Cover'
    }
  ];

  detailView = {
    currentTab: 0
  };

  activeMapLayers = [];
  radius = false;
  isRadiusActive = false;

  sidebarExpanded = false;

  constructor() {
    makeObservable(this, {
      isAnalysisPanelOpen: observable,
      controlPanelState: observable,
      version: observable,
      REGISTRATION_VERSION: observable,
      feedbackModalOpen: observable,
      searchFiltersState: observable,
      isSpeedDialOpen: observable,
      isMapVisible: observable,
      isContentVisible: observable,
      mapLayers: observable,
      detailView: observable,
      activeMapLayers: observable,
      radius: observable,
      isRadiusActive: observable,
      sidebarExpanded: observable,
      layoutClass: computed,
      setRadius: action,
      setRadiusActive: action,
      setSearchPanelState: action,
      setSearchFiltersState: action,
      setSidebarExpanded: action,
      setIsSpeedDialOpen: action,
      setActiveLayer: action,
      setIsMapVisible: action,
      setIsContentVisible: action
    });
  }

  get layoutClass() {
    return [
      this.sidebarExpanded ? 'nav-expanded' : '',
      this.isContentVisible ? 'content-visible' : '',
      this.isMapVisible ? 'map-visible' : '',
      this.isSpeedDialOpen ? 'speeddial-visible' : ''
    ]
      .join(' ')
      .trim();
  }

  setRadius(value) {
    this.radius = value;
  }

  setRadiusActive(value) {
    this.isRadiusActive = value;
  }

  setSearchPanelState(state) {
    this.controlPanelState = state;
  }

  setSearchFiltersState(state) {
    this.searchFiltersState = state;
  }

  setSidebarExpanded(isExpanded) {
    this.sidebarExpanded = isExpanded;
  }

  setIsSpeedDialOpen(isOpen) {
    this.isSpeedDialOpen = isOpen;
  }

  setActiveLayer(layerName, isActive) {
    if (isActive) {
      this.activeMapLayers = [...this.activeMapLayers, layerName];
    } else {
      this.activeMapLayers = [...this.activeMapLayers, layerName].filter(
        layer => layer !== layerName
      );
    }
  }

  setAnalysisPanelOpen(isOpen) {
    this.isAnalysisPanelOpen = isOpen;
  }

  setActiveMapLayers(mapLayers) {
    this.activeMapLayers = mapLayers;
  }

  setIsMapVisible(isVisible) {
    this.isMapVisible = isVisible;
  }

  setIsContentVisible(isVisible) {
    this.isContentVisible = isVisible;
  }

  setFeedbackModalOpen(open) {
    this.feedbackModalOpen = open;
  }

  setUIVersion(version) {
    this.version = version;
  }
  setREGISTRATION_VERSION(version) {
    this.REGISTRATION_VERSION = version;
  }
}

const store = new Store();
export default store;
